import { FlowStatus } from "@validereinc/domain";
import { convertMapToOpts } from "../shared/index.ts";
import { toTitleCaseString } from "@validereinc/utilities";

export const FlowStatusOptions = convertMapToOpts(FlowStatus, ([_, value]) =>
  toTitleCaseString(value)
);
